SupportAPIHelper = require('../helpers/API')
Backbone = require 'backbone'

class SupportHoldTimeModel extends Backbone.Model

  initialize: ->
    @mainView = @attributes.mainView

  getCallMeBackFlag:()->
    url = @getHoldTimeUrlToFetchCallMeBackFlag()
    SupportAPIHelper.get url, null, @mainView.callMeBackFlagCb, @mainView.callMeBackFlagCb, false

  postToHoldTime: (data)->
    url = @getHoldTimeUrlToPostInHoldTime()
    SupportAPIHelper.call url, 'POST', data, @mainView.renderHoldTimePostSuccess, @mainView.renderHoldTimePostError, false

  getHoldTimeUrlToFetchCallMeBackFlag:() ->
    channel = @getHoldTimeQueueChannel()
    url = "#{window.SUPPORTBASEURL}/hold_time/fetch?channel=#{channel}"

  getHoldTimeUrlToPostInHoldTime:() ->
    channel = @getHoldTimeQueueChannel()
    url = "#{window.SUPPORTBASEURL}/hold_time/create?channel=#{channel}"

  getHoldTimeQueueChannel:()->
    channel = Groupon.Support.currentOrder?.DEAL_TYPE
    goodsRegex = /goods/
    getawaysRegex = /getaways/
    holdTimeQueueChannel = 'local'

    if channel?
      holdTimeQueueChannel = if goodsRegex.test(channel.toLowerCase())
        'goods'
      else if getawaysRegex.test(channel.toLowerCase())
        'travel'
      else
        'local'

    holdTimeQueueChannel

module.exports = SupportHoldTimeModel
